const statTranslations = ['stat', 'order'];

module.exports = {
  locales: ['en-US', 'id-ID', 'ms-MY', 'th-TH', 'vi-VN', 'zh-CN', 'zh-TW'],
  defaultLocale: 'en-US',
  localeDetection: true,
  logger: false,
  // redirectToDefaultLang: true,
  pages: {
    '*': ['common', 'notify', 'tour'],
    'rgx:^/advertisers/reports/': ['statSummary'],
    'rgx:^/advertisers/easy-stores/*': ['easyStoreSetup'],
    '/advertisers': ['dashboard', 'imageCreative', 'textCreative', 'affiliate'],
    '/advertisers/affiliates': ['affiliate', 'campaign', 'marketplace'],
    '/advertisers/announcements': ['feed'],
    '/advertisers/api-keys': ['apiKey'],
    '/advertisers/balances': ['advertiserBalance'],
    '/advertisers/banners': ['imageCreative'],
    '/advertisers/campaigns': ['campaign', 'affiliate'],
    '/advertisers/documentation/api': ['docs', 'apiKey'],
    '/advertisers/documentation/tracking': ['docs', 'apiKey'],
    '/advertisers/downloads': ['download'],
    '/advertisers/faqs': ['faqFeed'],
    '/advertisers/login': ['login'],
    '/advertisers/users/login': ['login'],
    '/advertisers/users/profile': ['profile', 'network'],
    '/advertisers/offers': ['offer'],
    '/advertisers/notifications': ['notification'],
    '/advertisers/order-inquiries': ['missingOrder', 'order', 'stat'],
    '/advertisers/marketplace': ['marketplace', 'affiliate', 'emailTemplate'],
    '/advertisers/marketplace/invites': ['affiliate', 'marketplace', 'emailTemplate'],
    '/advertisers/products': ['product'],
    '/advertisers/product-apis': ['clientApi'],
    '/advertisers/profile': ['profile', 'network'],
    '/advertisers/promo-deals': ['textCreative'],
    '/advertisers/reports/affiliation': ['affiliation'],
    '/advertisers/register': ['network', 'register'],
    '/advertisers/register/success': ['register'],
    '/advertisers/register/verification': ['register'],
    '/advertisers/register/verify': ['register'],
    '/advertisers/transactions/captured': statTranslations,
    '/advertisers/transactions/clicks': statTranslations,
    '/advertisers/transactions/confirmed': statTranslations,
    '/advertisers/transactions/pending': ['stat'],
    '/advertisers/transactions/pending/by-offer/[offerId]': ['stat'],
    '/advertisers/transactions/published': statTranslations,
    '/advertisers/transactions/upload': ['stat', 'uploadInstruction', 'upload'],
    '/advertisers/uploads': ['upload'],
    '/advertisers/widgets/affiliate-signup-link': ['widget'],
  },
};
